

export function getDifferenceBetweenDates(date1: string, date2: string): number {
  const d1 = new Date(date1);
  const d2 = new Date(date2);

  // Diferencia en milisegundos
  const diffMs = Math.abs(d2.getTime() - d1.getTime());

  // Convertir a horas
  const diffHours = diffMs / (1000 * 60 * 60);

  return diffHours;
}
